import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["paymentMethodId", "id", "className", "children", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/PaymentSelect.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PaymentRadioButton(_ref, ref) {
  let {
      paymentMethodId,
      id,
      className,
      children,
      disabled
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.paymentInput, {
      [styles.disabled]: disabled
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        type: "radio",
        name: "paymentMethod",
        id: id,
        disabled: disabled
      }, props)), /*#__PURE__*/_jsxs("label", {
        htmlFor: id,
        className: className,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.check
        }), children]
      })]
    })
  });
}
export default /*#__PURE__*/forwardRef(PaymentRadioButton);